import notificationSoundUrl from '@/assets/new-notification.wav'

let audio: HTMLAudioElement | null = null

/**
 * Toca o aviso sonoro de notificação (nova conversa, atribuição, push em
 * geral — ver showPushNotification). Silencioso em qualquer falha: política
 * de autoplay do navegador sem interação prévia do usuário não pode quebrar
 * o fluxo de notificação em si.
 */
export function playNotificationSound(): void {
  try {
    if (!audio) audio = new Audio(notificationSoundUrl)
    audio.currentTime = 0
    void audio.play().catch(() => { /* autoplay bloqueado — ignora */ })
  } catch {
    /* ambiente sem suporte a Audio (ex.: testes) — ignora */
  }
}
